//J1M2 沒有指定affcode 有需要再加入
const affDomains = {
    //"localhost" : 'J106542',
}

export default affDomains;
